import { useNavigate } from "@tanstack/react-router"
import { IconCircleWarningOutline18 as CircleAlert } from "nucleo-ui-outline-18"

import { Button } from "@productlane/ui"

import { useZeroWorkspace } from "@/lib/zero"

export function LinearReconnectRequiredBanner() {
	const workspace = useZeroWorkspace()
	const navigate = useNavigate()

	if (!workspace || !workspace.linearTokenRevoked) {
		return null
	}

	return (
		<div className="mx-4 mb-4 flex select-none flex-col gap-3 rounded-lg border bg-gray-100 px-3 py-4 shadow-md dark:bg-gray-850">
			<div className="flex flex-row items-center gap-1 text-xs font-medium">
				<CircleAlert className="mr-1 h-4 w-4 stroke-yellow-400" />
				Reconnect Linear
			</div>
			<div className="mb-1 text-xxs font-normal text-secondary">
				We’ve made updates to our Linear integration. Please reconnect Linear in
				the settings to continue using it without interruptions.
			</div>
			<Button
				onClick={() => void navigate({ to: "/settings/integrations/linear" })}
				className="w-min"
			>
				Open settings
			</Button>
		</div>
	)
}

export function LinearReconnectRequiredBannerCollapsed() {
	const workspace = useZeroWorkspace()

	if (!workspace || !workspace.linearTokenRevoked) {
		return null
	}

	return (
		<div className="mb-2 flex w-full justify-center pl-1.5">
			<CircleAlert className="mr-1 h-5 w-5 stroke-yellow-400" />
		</div>
	)
}
